module.exports = __webpack_public_path__ + "img/icon-phone-0.126777f0.png";